import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const fireGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // fireGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.FIRE) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const firePlans = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // firePlans is 2
    if (appID !== constAppID.FIRE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'fireQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const fireRisk = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // fireRisk is 3
    if (appID !== constAppID.FIRE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'fireQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'fireQuotePlans' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const firePremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // firePremium is 4
    if (appID !== constAppID.FIRE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'fireQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'fireQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'fireQuoteRisk' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const firePayment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // firePayment is 5
    if (appID !== constAppID.FIRE) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'fireQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'fireQuotePlans' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'fireQuoteRisk' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'fireQuotePremium' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
